import Vue from 'vue'
import Router from 'vue-router'

import { store } from '../main.js'

import Home from './home'
import Login from './login'
import User from './user'
import Profile from './profile'
import Company from './company'
import Branch from './branch'
import Sector from './sector'
import Role from './role'
import Documents from './documents'
import SignatureBatch from './signatureBatch'
import SignatureUser from './signatureUser'
import ViewingGroups from './viewingGroups'
import Extract from './extract'
import MultipleSignature from './multipleSignature'
import Detatched from './detatched'
import Graph from './graph'
import Settings from './settings'
import Regionals from './regionals'
import Pending from './pending'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    linkActiveClass: "active",
    hashbang: false,
    routes: [
        Login,
        Home,
        User,
        Profile,
        Company,
        Branch,
        Sector,
        Role,
        Documents,
        SignatureBatch,
        SignatureUser,
        Extract,
        MultipleSignature,
        ViewingGroups,
        Detatched,
        Graph,
        Settings,
        Regionals,
        Pending
    ]
});

router.beforeEach(async (to, from, next) => {
    if (!store.state.authInitialized) {
        await store.dispatch('initialize');
    }

    const authenticated = store.getters.authenticated;
    let to_splited = to.path.toString().split('/')
    to_splited = to_splited.filter(part => part !== '')

    if (
        !authenticated &&
        (
            !(['/login'].includes(to.path.toString())) &&
            !(['signDocumentByHash'].includes(to_splited[0])) &&
            !(['myPending'].includes(to_splited[0]))
        )
    ){
        next('/login');

        return true;
    }

    if (authenticated && to.path.toString() == '/login') {
        next('/');

        return true;
    }

    next();
});

router.afterEach((to, from) => {
    let _name = to.name;
    let _route = to.fullPath;

    if (_name === 'Home') {
        _name = '';
        _route = '';
    }

    store.commit("updateBreadCrumbs", { name: _name, route: _route })
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js